export function usePagination(options) {
    const { offset, limit, count, setOffset } = options;
    const span = 5;
    const totalPages = Math.ceil(count / limit);
    const pagesArray = Array.from(Array(totalPages).keys());
    const pageSections = pagesArray.reduce((acc, current) => {
        const index = Math.floor(current / span);
        const tmp = [...acc];
        if (!Array.isArray(tmp[index])) {
            tmp[index] = [];
        }
        const pageNumber = current + 1;
        const value = current * limit;
        tmp[index].push({ pageNumber, value });
        return tmp;
    }, []);
    const section = Math.floor(offset / (limit * span));
    const pages = pageSections[section];
    function prev() {
        if (offset > 0) {
            return () => setOffset(offset - limit);
        }
        return undefined;
    }
    function next() {
        const lastPage = totalPages - 1;
        if (offset / limit < lastPage) {
            return () => setOffset(offset + limit);
        }
        return undefined;
    }
    return { totalPages, pages, prev: prev(), next: next() };
}
